import { Card,Tooltip,Image,Row, Col  } from 'antd';

import React, { useState } from 'react';
import {useMoralisWeb3Api, useMoralisWeb3ApiCall} from 'react-moralis'

const  {Meta} = Card
const MintNFTs = () => {
 

  return <div className='mint-container'>
   <img src='/comingsoon.svg' alt='coming soon' className='coming_svg' />
   <h2 style={{fontSize: "1.9rem", fontWeight: "500", marginTop: "10px"}}>Coming Soon</h2>
   <h3 >Our team is hard at work to bring you gasless minting</h3>
  </div>;
}



export default MintNFTs;
